let _ = require('lodash');

module.exports = {
    /**
     * Выполняем работу после промиса, ловим ошибки
     * @param {Object} promise
     * @param {Function} dataFunction
     * @param {Object} output
     */
    thenWithErrorHandling: function (promise, dataFunction, output) {
        promise.then((data) => {
            if (_.get(data, 'status.code') !== 200) {
                output.error({ error: _.get(data, 'status.code') });
                return;
            }
            output.success(dataFunction(data));
        }).catch((error) => {
            output.error({ error });
        });
    }
};



// WEBPACK FOOTER //
// ./helpers/errorHandler.js